import React from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';


import "./actionTable.css"


const config = window.config;

const ErrorDialog = (props) => {
    let {  onClose, errors,errorGroups } = props;
    const vertical= "top";
    const horizontal="center";

    const handleClose = (value) => {
        onClose(value);
    };

    if(errorGroups!== "" && errorGroups!== undefined){errors+=1}

    if(errors!== undefined && errors!==0 )
    {
        return (
            <Snackbar
                anchorOrigin={{ vertical, horizontal }}
                open={errors.length!==0} autoHideDuration={4000} onClose={handleClose}>
                <Alert elevation={6} onClose={handleClose} severity="error">
                    {errors} Errors Found
                </Alert>
            </Snackbar>);
    }
    else{
        return <Snackbar
            anchorOrigin={{ vertical, horizontal }}
            open={errors === 0} autoHideDuration={4000} onClose={handleClose}>
            <Alert elevation={6} onClose={handleClose} severity="success" variant="filled">
                No Errors Found. Ready to Submit
            </Alert>
        </Snackbar>;
    }
}

export default ErrorDialog;